import React, { useState } from "react";
import { Link } from "gatsby";
import NewletterModal from "../common/NewletterModal";

const BlogContent = ({ data }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className="blogContent">
      <h1>{data.title}</h1>
      {!!data.images?.length &&
        data.images?.map((image, index) => (
          <div key={index}>
            <img
              src={image}
              alt={data.title}
              loading="eager"
              className="thumbnail__image"
            />
            <img
              src={image}
              alt={data.title}
              loading="eager"
              className="thumbnail__image__mobile"
            />
          </div>
        ))}

      <div className="content">
        <div
          dangerouslySetInnerHTML={{
            __html: data.body,
          }}
        />
      </div>

      <div className="my-10">
        <button
          className="border-btn-rounded-white d-none d-lg-inline-flex no-underline"
          onClick={() => setOpenModal(true)}
        >
          Subscribe
        </button>
      </div>

      {!!data?.categories?.length && (
        <div className="tag__container">
          <h6>
            Categories:
            <div className="space-x-1 ml-2 pl-0 inline-block">
              {data?.categories?.map((category, index) => (
                <Link key={index} to={`/${category.slug}`}>
                  <span>{category.name}</span>
                  {data.categories?.length > index + 1 && ","}
                </Link>
              ))}
            </div>
          </h6>
        </div>
      )}
      {!!data?.tags?.length && (
        <div className="tag__container">
          <h6>
            Tags:
            <div className="space-x-1 ml-2 pl-0 inline-block">
              {data?.tags?.map((tag, index) => (
                <Link key={index} to={`/${tag.slug}`}>
                  <span>{tag.name}</span> {data.tags?.length > index + 1 && ","}
                </Link>
              ))}
            </div>
          </h6>
        </div>
      )}

      {openModal && <NewletterModal closeModal={() => setOpenModal(false)} />}
    </div>
  );
};

export default BlogContent;
